export default "__VITE_ASSET__BWFEjqPN__"